require('./transferMoneyFinalStep.scss');

const PropTypes = require('prop-types');

// @ vendor
const React = require('react');

// @ commons
const { formatText, FormattedText } = require('core/i18n').i18n;
const WizardSuccess = require('components/commons/wizardSuccess/wizardSuccess');
const WizardError = require('components/commons/wizardError/wizardError');

// @ helpers
const { getFormattedString } = require('utilities/currencyHelper');

class TransferMoneyFinalStep extends React.Component {
    constructor(props) {
        super(props);

        this.buildSuccess = this.buildSuccess.bind(this);
        this.buildError = this.buildError.bind(this);
    }

    buildError() {
        const errorTitle = formatText('cardTransferMoney-errorTitle');
        const goBackButtonLabel = formatText('cardTransferMoney-backToCards').toUpperCase();
        const linkToDetails = '/myprofile/cards';
        const mainButton = {
            label: goBackButtonLabel,
            url: linkToDetails
        };

        return (
            <WizardError
                errorMessage={errorTitle}
                mainButton={mainButton}
            >
                <section className="transfer-money-final-step__content row">
                    <p className="transfer-money-final-step__error-message">
                        <FormattedText value="cardTransferMoney-errorMessage" />
                    </p>
                </section>
            </WizardError>
        );
    }

    buildSuccess() {
        const { immCard, immStep, immAccounts, accountsIndexes } = this.props;
        const amount = immStep.get('amount');
        const goBackButtonLabel = formatText('cardTransferMoney-backToCards').toUpperCase();
        const linkToDetails = '/myprofile/cards';
        const goBackButton = {
            label: goBackButtonLabel,
            url: linkToDetails
        };
        const amountObject = {
            amount,
            currency: immCard.get('availableBalance').get('currency')
        };
        const commissionObject = {
            amount: immStep.get('commission'),
            currency: immCard.get('availableBalance').get('currency')
        };
        const amountLabel = getFormattedString(amountObject);
        const commission = getFormattedString(commissionObject);
        const immAccount = immAccounts.get(accountsIndexes[0]);
        const alias = immAccount.get('iban').substr(-4);

        const successTitle = formatText('cardTransferMoney-successTitle', [alias, amountLabel]);
        const errorMessage = formatText('cardTransferMoney-commissionAmount', [commission]);

        return (
            <WizardSuccess
                successMessage={successTitle}
                mainButton={goBackButton}>
                <section className="transfer-money-final-step__content row">
                    <p className="transfer-money-final-step__commission-amount">{errorMessage}</p>
                </section>
            </WizardSuccess>
        );
    }

    render() {
        let finalBlock;

        if (!this.props.errorState) {
            finalBlock = this.buildSuccess();
        } else {
            finalBlock = this.buildError();
        }

        return (
            <article className="transfer-money-final-step">
                {finalBlock}
            </article>
        )
    }
}

TransferMoneyFinalStep.propTypes = {
    immCard: PropTypes.object,
    immStep: PropTypes.object,
    errorState: PropTypes.bool,
    immAccounts: PropTypes.object,
    accountsIndexes: PropTypes.array
};

module.exports = TransferMoneyFinalStep;
